import { memo, useMemo } from 'react';
import { useTranslation } from '@bonanza-social/i18n';
import { useSelector } from '@bonanza-social/toolkit/state';
import { Text } from '@bonanza-social/moonlight';
import { selectCommunityJackpotEvents } from '../../../../state';
import {
  getMilestoneWinners,
  getMilestoneContributors,
  isEventEnded,
} from '../JackpotProgress.utils';
import { JackpotProgressFooterProps } from './JackpotProgressFooter.types';

function JackpotProgressFooter({
  showLastMilestoneHit,
  prevActiveMilestone,
  activeMilestone,
}: JackpotProgressFooterProps) {
  const { t } = useTranslation('communityJackpot');
  const [event] = useSelector(selectCommunityJackpotEvents);
  const showWinners = useMemo(() => isEventEnded(event), [event]);
  const milestoneWinners = useMemo(() => getMilestoneWinners(event), [event]);
  const milestoneContributors = useMemo(
    () =>
      getMilestoneContributors(
        showLastMilestoneHit,
        prevActiveMilestone,
        activeMilestone,
      ),
    [showLastMilestoneHit, activeMilestone, prevActiveMilestone],
  );

  return (
    <Text
      variant="caption"
      color="darkSurfacePrimary"
      paddingTop="space-400"
      textAlign="center"
    >
      {showWinners
        ? t('eventWinners', { count: milestoneWinners })
        : t('eventContributors', { count: milestoneContributors })}
    </Text>
  );
}

export default memo(JackpotProgressFooter);
